(ns frontend.ui.page.lp-report-editor.controller
  (:require
   [frontend.routing :as routing]
   [frontend.ui.page.lp-report-editor.view :as view]
   [frontend.ui.page.lp-report-editor.event :as event]
   [re-frame.core :as rf]))

(defn- view
  [report-id]
  [view/editor-view report-id])

(defmethod routing/render-view :lp-portal/report-editor
  [{:keys [route-params]}]
  (let [{:keys [fund-id id]} route-params
        fund-id (long fund-id)
        report-id (long id)]
    (rf/dispatch [::event/reset-editor report-id fund-id])
    ;; Don't inline this `view` function: for a reason (maybe related to the use
    ;; of multi-method), inlining it prevents navigating away from the page.
    [view report-id]))

